"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.socialMedia.column.platform': 'Platform',
    'settings.socialMedia.column.status': 'Status',
    'settings.socialMedia.x.title': 'X (Twitter)',
    'settings.socialMedia.x.description': 'Connect your X account to enable posting.',
    'settings.socialMedia.x.connect': 'Connect X',
    'settings.socialMedia.x.disconnect': 'Disconnect X',
    'settings.socialMedia.x.disconnected': 'X disconnected',
    'settings.socialMedia.x.connectFailed': 'Failed to connect X',
    'settings.socialMedia.x.disconnectFailed': 'Failed to disconnect X',
    'settings.socialMedia.ig.title': 'Instagram',
    'settings.socialMedia.ig.description': 'Connect your Instagram Business account to enable posting.',
    'settings.socialMedia.ig.connect': 'Connect Instagram',
    'settings.socialMedia.ig.disconnect': 'Disconnect Instagram',
    'settings.socialMedia.ig.disconnected': 'Instagram disconnected',
    'settings.socialMedia.ig.connectFailed': 'Failed to connect Instagram',
    'settings.socialMedia.ig.disconnectFailed': 'Failed to disconnect Instagram',
    'settings.socialMedia.fb.title': 'Facebook',
    'settings.socialMedia.fb.description': 'Connect your Facebook account to enable posting.',
    'settings.socialMedia.fb.connect': 'Connect Facebook',
    'settings.socialMedia.fb.disconnect': 'Disconnect Facebook',
    'settings.socialMedia.fb.disconnected': 'Facebook disconnected',
    'settings.socialMedia.fb.connectFailed': 'Failed to connect Facebook',
    'settings.socialMedia.fb.disconnectFailed': 'Failed to disconnect Facebook',
    'settings.socialMedia.yt.title': 'YouTube',
    'settings.socialMedia.yt.description': 'Connect your YouTube channel to enable video publishing.',
    'settings.socialMedia.yt.connect': 'Connect YouTube',
    'settings.socialMedia.yt.disconnect': 'Disconnect YouTube',
    'settings.socialMedia.yt.disconnected': 'YouTube disconnected',
    'settings.socialMedia.yt.connectFailed': 'Failed to connect YouTube',
    'settings.socialMedia.yt.disconnectFailed': 'Failed to disconnect YouTube',
    'settings.socialMedia.tt.title': 'TikTok',
    'settings.socialMedia.tt.description': 'Connect your TikTok account to enable video publishing.',
    'settings.socialMedia.tt.connect': 'Connect TikTok',
    'settings.socialMedia.tt.disconnect': 'Disconnect TikTok',
    'settings.socialMedia.tt.disconnected': 'TikTok disconnected',
    'settings.socialMedia.tt.connectFailed': 'Failed to connect TikTok',
    'settings.socialMedia.tt.disconnectFailed': 'Failed to disconnect TikTok',
    'settings.socialMedia.li.title': 'LinkedIn',
    'settings.socialMedia.li.description': 'Connect your LinkedIn account to enable posting.',
    'settings.socialMedia.li.connect': 'Connect LinkedIn',
    'settings.socialMedia.li.disconnect': 'Disconnect LinkedIn',
    'settings.socialMedia.li.disconnected': 'LinkedIn disconnected',
    'settings.socialMedia.li.connectFailed': 'Failed to connect LinkedIn',
    'settings.socialMedia.li.disconnectFailed': 'Failed to disconnect LinkedIn',
    'settings.socialMedia.pt.title': 'Pinterest',
    'settings.socialMedia.pt.description': 'Connect your Pinterest account to publish Pins.',
    'settings.socialMedia.pt.connect': 'Connect Pinterest',
    'settings.socialMedia.pt.disconnect': 'Disconnect Pinterest',
    'settings.socialMedia.pt.disconnected': 'Pinterest disconnected',
    'settings.socialMedia.pt.connectFailed': 'Failed to connect Pinterest',
    'settings.socialMedia.pt.disconnectFailed': 'Failed to disconnect Pinterest',
    'settings.socialMedia.th.title': 'Threads',
    'settings.socialMedia.th.description': 'Connect your Threads account to enable posting.',
    'settings.socialMedia.th.connect': 'Connect Threads',
    'settings.socialMedia.th.disconnect': 'Disconnect Threads',
    'settings.socialMedia.th.disconnected': 'Threads disconnected',
    'settings.socialMedia.th.connectFailed': 'Failed to connect Threads',
    'settings.socialMedia.th.disconnectFailed': 'Failed to disconnect Threads',
    'settings.socialMedia.dictionary.title': 'Social Media Dictionaries',
    'settings.socialMedia.dictionary.type': 'Type',
    'settings.socialMedia.dictionary.type.tone': 'Tone',
    'settings.socialMedia.dictionary.type.goal': 'Goal',
    'settings.socialMedia.dictionary.type.audience': 'Audience',
    'settings.socialMedia.dictionary.key': 'Key',
    'settings.socialMedia.dictionary.label': 'Label',
    'settings.socialMedia.dictionary.icon': 'Icon',
    'settings.socialMedia.dictionary.order': 'Order',
    'settings.socialMedia.dictionary.active': 'Active',
    'settings.socialMedia.dictionary.add': 'Add',
    'settings.socialMedia.dictionary.edit': 'Edit',
    'settings.socialMedia.dictionary.delete': 'Delete',
    'settings.socialMedia.dictionary.editTitle': 'Edit Dictionary Item',
    'settings.socialMedia.dictionary.addTitle': 'Add Dictionary Item',
    'settings.socialMedia.dictionary.save': 'Save',
    'settings.socialMedia.dictionary.cancel': 'Cancel',
    'settings.socialMedia.dictionary.loadFailed': 'Failed to load dictionaries',
    'settings.socialMedia.dictionary.fillRequired': 'Please fill in all required fields',
    'settings.socialMedia.dictionary.saved': 'Dictionary item saved',
    'settings.socialMedia.dictionary.saveFailed': 'Failed to save dictionary item',
    'settings.socialMedia.dictionary.deleted': 'Dictionary item deleted',
    'settings.socialMedia.dictionary.deleteFailed': 'Failed to delete dictionary item',
    'settings.socialMedia.dictionary.deleteConfirm': 'Are you sure you want to delete this dictionary item?',
};
